import React, { Fragment } from 'react';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Button from '@material-ui/core/Button';
import { FieldArray } from 'formik';
import { TextField } from 'components/form/Formik/index';
import QuestionBlock from './QuestionBlock';
import { INPUT_TYPE } from 'constant/form-builder';

const useStyles = makeStyles(() => ({
  questionGroup: {
    marginBottom: 16,
    border: '1px solid #eee',
    padding: 8,
    borderRadius: 4,
  },
  remove: {
    textAlign: 'right',
    marginTop: 8,
  },
}));

const BlockQuestions = React.memo(
  ({ classes, blockIndex, index, question, remove }) => {
    return (
      <div className={classes.questionGroup}>
        <div>
          <QuestionBlock
            block={question}
            name={`blocks.${blockIndex}.questions.${index}`}
          />
        </div>
        <div className={classes.remove}>
          <Button
            startIcon={<DeleteForeverIcon />}
            size="small"
            color="secondary"
            onClick={() => remove(index)}
          >
            Remove question
          </Button>
        </div>
      </div>
    );
  },
);

const QuestionGroupBlock = ({ index, block }) => {
  const classes = useStyles();
  return (
    <Fragment>
      <TextField name={`blocks.${index}.title`} placeholder="Section title" />
      <TextField
        rows={3}
        name={`blocks.${index}.description`}
        placeholder="Optional description"
      />
      <FieldArray
        name={`blocks.${index}.questions`}
        render={(helper) => (
          <div>
            {block.questions?.map((q, i) => {
              return (
                <BlockQuestions
                  key={i}
                  index={i}
                  blockIndex={index}
                  question={q}
                  classes={classes}
                  remove={helper.remove}
                />
              );
            })}
            <div>
              <Button
                startIcon={<AddIcon />}
                onClick={() =>
                  helper.push({ type: INPUT_TYPE.TEXT })
                }
              >
                Add question
              </Button>
            </div>
          </div>
        )}
      />
    </Fragment>
  );
};

export default QuestionGroupBlock;
